import { render, staticRenderFns } from "./fsDialog_component.vue?vue&type=template&id=48eb2fe8&scoped=true&"
import script from "./fsDialog_component.vue?vue&type=script&lang=js&"
export * from "./fsDialog_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb2fe8",
  null
  
)

export default component.exports